<template>
  <div class="c-open-list">
    <ul class="open-list">
      <li class="open-list__item" v-for="item of list" :key="item.link">
        <open-item :label="item.label" :link="item.link" :type="item.type" />
      </li>
    </ul>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import OpenItem from '@/components/Global/OpenItem.vue';

export default defineComponent({
  name: 'OpenList',
  components: {
    OpenItem,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
<style lang="scss" scoped>
.open-list {
  &__item {
    & + & {
      margin-top: 20px;
    }
  }
}

// .dw-box {
//   @include flex(flex-start, flex-start);

//   &__text {
//     @include font-style($c-main, 16, 500, 1.6px, 32px);
//   }

//   &__img {
//     margin-left: 8px;
//   }
// }

@media screen and (min-width: $portrait) {
  .open-list {
    @include flex(flex-start, flex-start);
    flex-wrap: wrap;

    &__item {
      width: 50%;
      &:nth-child(2) {
        margin-top: 0px;
      }
    }
  }
}

@media screen and (min-width: $tablet) {
  .open-list {
    @include flex(flex-start, flex-start);
    flex-wrap: wrap;

    &__item {
      width: 25%;
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4) {
        margin-top: 0px;
      }
    }
  }
}
</style>
